<template>
  <v-container
    grid-list-xl
    fluid
  >
    <LoadingState
      :loading="loading"
      color="primary"
    />
    <v-layout
      v-if="!loading"
      row
      wrap
    >
      <v-flex
        xs12
      >
        <UserProfile :user="user" />
        <UserPassword :user="user" />
        <UserRoles :user="user" />
        <UserPermissions :user="user" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UserProfile from './UserProfile'
import UserPassword from './UserPassword'
import UserRoles from './UserRoles'
import UserPermissions from './UserPermissions'
import LoadingState from '@/components/LoadingState'

export {
  UserProfile
}

export default {
  name: 'UserSingle',

  components: {
    LoadingState,
    UserProfile,
    UserPassword,
    UserRoles,
    UserPermissions
  },

  props: {
    user: {
      type: Object,
      required: true
    }
  },

  computed: {
    loading () {
      return Object.entries(this.user).length === 0
    },

    title () {
      return (
        this.user && `${this.user.name}`
      )
    },

    disabled () {
      return this.user.inProgress || !this.user.isChanged
    }
  }
}
</script>
